import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tariff.reducer';

export const TariffDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tariffEntity = useAppSelector(state => state.tariff.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tariffDetailsHeading">
          <Translate contentKey="crawlerBackendApp.tariff.detail.title">Tariff</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{tariffEntity.id}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="crawlerBackendApp.tariff.type">Type</Translate>
            </span>
          </dt>
          <dd>{tariffEntity.type}</dd>
          <dt>
            <span id="productType">
              <Translate contentKey="crawlerBackendApp.tariff.productType">Product Type</Translate>
            </span>
          </dt>
          <dd>{tariffEntity.productType}</dd>
          <dt>
            <span id="isFixedTariff">
              <Translate contentKey="crawlerBackendApp.tariff.isFixedTariff">Is Fixed Tariff</Translate>
            </span>
          </dt>
          <dd>{tariffEntity.isFixedTariff ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.tariff.productOfferingPrice">Product Offering Price</Translate>
          </dt>
          <dd>
            {tariffEntity.productOfferingPrices
              ? tariffEntity.productOfferingPrices.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {tariffEntity.productOfferingPrices && i === tariffEntity.productOfferingPrices.length - 1
                      ? ''
                      : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/tariff" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tariff/${tariffEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TariffDetail;
